module.exports = __webpack_public_path__ + "img/ma.c9edb01b.svg";